import { NavigationClient } from '@azure/msal-browser';
/**
 * This overrides the default function that MSAL uses to navigate to other urls within the app after authentication
 */
export class CustomNavigationClient extends NavigationClient {
    constructor(history) {
        super();
        Object.defineProperty(this, "history", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.history = history;
    }
    /**
     * Override MSAL navigateInternal method to allow for client-side routing within SPA
     */
    async navigateInternal(url, options) {
        const relativePath = url.replace(window.location.origin, '');
        if (options.noHistory) {
            this.history.replace(relativePath);
        }
        else {
            this.history.push(relativePath);
        }
        return false;
    }
}
//# sourceMappingURL=CustomNavigationClient.js.map